// extracted by mini-css-extract-plugin
module.exports = {"updatePasswordTitle":"updatePasswordTitle[Frida]9zj6PemI","firstColumn":"firstColumn[Frida]fqSPaOhM","saveButton":"saveButton[Frida]20tivN8w"};